import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PFieldAbstractComponent } from '../p-field-abstract';
import { ProgressBarItem } from '@frontend-site/shared/data';

@Component({
    selector: 'p-field-multiple-progress-bar',
    template: `<p-field [label]="label" [isReadOnly]="true">
        <p-multiple-progress-bar
            slot="readMode"
            [values]="value ?? []"
            [linkLabelPart]="linkLabelPart || value?.[0]?.value"
            [label]="label"
            [displayTooltip]="true"
            (linkClicked)="linkClicked.emit()"
        ></p-multiple-progress-bar>
    </p-field>`,
    styleUrls: ['./p-field-multiple-progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldMultipleProgressBarComponent
        }
    ],
    exportAs: 'pFieldMultipleProgressBar'
})
export class PFieldMultipleProgressBarComponent extends PFieldAbstractComponent<ProgressBarItem[]> {
    @Input() label = '';
    @Input() linkLabelPart = 0;
    @Output() linkClicked = new EventEmitter();

    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }
}
